import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchContractDetails, fetchTelephony } from 'slices/contract'
import { setModal } from 'slices/modal'
import { MODAL_KEYS } from 'app-constants'
import { fetchIsEligibleToBuy } from 'slices/store'
import { useDashboardRedirect } from '../use-dashboard-redirect'
import { useDashboardMessages } from '../use-dashboard-messages'

export function useDashboard() {
  const customer = useSelector(customerSelector)
  const selectedContract = useSelector(selectedContractSelector)
  const contractDetails = useSelector(contractDetailsSelector)
  const userBankSlips = useSelector(financialSelector)
  const { hasPendingNegotiated, daysToBreachOfAgreement } = userBankSlips
  const dispatch = useDispatch()
  useDashboardRedirect(selectedContract)
  useDashboardMessages(selectedContract)

  const { contractId, detail } = useSelector(({ contract }) => ({
    contractId: contract.selected.id,
    detail: contract.detail,
  }))

  useEffect(() => {
    function handleBreachOfAgreement() {
      if (hasPendingNegotiated) {
        dispatch(
          setModal({
            key: MODAL_KEYS.DAYS_TO_BREACH_AGREEMENT,
            data: { days: daysToBreachOfAgreement },
          })
        )
      }
    }

    handleBreachOfAgreement()
  }, [hasPendingNegotiated, daysToBreachOfAgreement, dispatch])

  useEffect(() => {
    async function handleUserStoreEligibility() {
      dispatch(fetchIsEligibleToBuy(contractId))
    }

    async function handleContractDetails() {
      dispatch(fetchContractDetails(contractId))
    }

    handleUserStoreEligibility()
    handleContractDetails()
  }, [contractId, dispatch])

  useEffect(() => {
    if (detail?.hasTelephony) {
      dispatch(fetchTelephony(contractId))
    }
  }, [contractId, detail, dispatch])

  function financialSelector(state) {
    const { bankSlips } = state.financial

    return bankSlips
  }

  function customerSelector(state) {
    const { name, contacts } = state.customer.info
    return { name, contacts }
  }

  function selectedContractSelector(state) {
    const { selected } = state.contract
    return selected
  }

  function contractDetailsSelector(state) {
    return state.contract.detail
  }

  return { customer, selectedContract, contractDetails }
}
